module.exports = __webpack_public_path__ + "static/01-d433224010e7b4e90c1b1d25ab4fdaa0.png";